(function () {
  var EMOJI = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}\u{FE0F}\u{200D}]/gu;
  var EMOJI_START = /^\s*[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{2B00}-\u{2BFF}]/u;
  var BULLET = /^\s*(?:[●•·▪■◦○▸►✓✔✅*]+|[-–—](?=\s))\s*/;
  var KV = /^([^:]{1,48}):\s+(\S[\s\S]*)$/;
  var KV_TIGHT = /^([^:]{1,47}[A-Za-z)]):([^\s\/][\s\S]*)$/;
  var KV_DIM = /^(length|width|height|depth|diameter|thickness|weight)\s+(\d[\s\S]*)$/i;
  var RAW_TAGS = /^(TABLE|IMG|IFRAME|VIDEO|FIGURE|BLOCKQUOTE|PRE)$/;
  var TEXT_TAGS = /^(P|LI|SPAN|STRONG|B|EM|I|A|U|SMALL|SUB|SUP)$/;
  var T_INTRO = /^(product )?(description|overview|about)\b/i;
  var T_SPEC = /dimension|specification|\bspecs?\b|requirement/i;
  var T_LIST = /feature|ideal|highlight|benefit|why |application|use case/i;
  var T_CHECK = /feature|highlight|benefit/i;
  var T_META = /^(package contents?|what.?s in the box|in the box|box contents?|part numbers?(\(s\))?|model numbers?(\(s\))?|models?|item codes?(\(s\))?|sku|(available )?colou?rs?(\(s\))?( options)?|warranty)$/i;
  var T_TOP = /^((key |special |product |main |software |physical )?features?|technical|specifications?|dimensions?\b|product dimensions|package dimensions|ideal for|compatibility|system requirements|materials)/i;
  var T_BOX = /feature|specification|dimension|requirement|compatib/i;
  var T_TABLE = /specification|\bspecs?\b|technical/i;
  var SPLITS = [
    { title: 'Connectivity & Audio', re: /connectiv|\bports?\b|interface|wireless|wi-?fi|bluetooth|ethernet|\blan\b|\bwan\b|antenna|audio|speaker|microphone/i },
    { title: 'Power & Environment', re: /power|voltage|battery|consumption|noise|temperature|humidity|energy|operating (environment|conditions)/i },
    { title: 'Build & Security', re: /security|\block\b|positioning|mount|weight|housing|material|certif|compliance|warranty|safety|protection/i }
  ];
  var T_CODES = /^(part|model|product|item) (numbers?|codes?|nos?\.?)|^models?$/i;
  var CODE_LINE = /^((?:part|model|product|item) (?:numbers?|codes?|nos?\.?)(?:\(s\))?)\s*[:\-–—]\s*(\S.{0,80})$/i;
  var T_COLOUR = /colou?r/i;
  var DIM_KEY = /^(length|width|height|depth|diameter|thickness|height ?(\/|or) ?thickness)$/i;
  var DIM_VAL = /^([\d.,]+)\s*(mm|cm|m|in|inch|inches|")(?![a-z])/i;
  var PRIORITY = [/capacity/i, /material/i, /paper size/i, /^colou?rs?\b/i, /weight/i, /security level|fire rating/i, /page yield/i, /processor/i, /memory|\bram\b/i, /storage/i, /screen|display/i, /connect/i, /battery|run ?time|discharge/i, /power/i, /size/i, /quantity|pack/i, /finish/i];
  var SWATCH = { black: '#1b1b1b', white: '#ffffff', grey: '#9aa0a6', gray: '#9aa0a6', silver: '#c9ced3', blue: '#2f6fd0', navy: '#122c5f', red: '#d6232b', green: '#2e9e5b', yellow: '#f2c230', orange: '#f08a24', brown: '#7a5234', beige: '#d9c7a8', cream: '#efe6d2', ivory: '#f4efe2', pink: '#ec8fb0', purple: '#7d4fc4', gold: '#c9a23f', oak: '#c8a26b', walnut: '#6b4a2f', maple: '#d9b98a', cherry: '#8e3b2f', mahogany: '#5c2a20', wenge: '#3d2b23', teal: '#1f8f8a', cyan: '#00a8d6', magenta: '#d6007f' };
  var CHECK_SVG = '<svg class="oru-check" width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false"><circle cx="10" cy="10" r="10" fill="currentColor"/><path d="M5.8 10.4l2.8 2.8 5.6-5.8" fill="none" stroke="#fff" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function clean(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function title(s) { return clean(s.replace(EMOJI, '')).replace(/[\s:：]+$/, ''); }
  function esc(s) { return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }
  function bare(s) { return s.replace(EMOJI, '').replace(/\s+/g, ''); }
  function strip(s) { return s.replace(/<[^>]+>/g, ''); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }

  // Split a paragraph-like element into lines at its <br> tags.
  function lines(el) {
    var doc = el.ownerDocument, out = [], cur = doc.createElement('div');
    // A <br> typed inside bold or a span still ends the line: lift it out of its wrapper first.
    if (el.querySelector('strong br,b br,em br,i br,span br,u br')) {
      el = el.cloneNode(true);
      each(el.querySelectorAll('br'), function (br) {
        var p = br.parentNode;
        while (p !== el && /^(STRONG|B|EM|I|SPAN|U)$/.test(p.tagName)) {
          var tail = p.cloneNode(false);
          while (br.nextSibling) tail.appendChild(br.nextSibling);
          p.parentNode.insertBefore(br, p.nextSibling);
          if (tail.childNodes.length) br.parentNode.insertBefore(tail, br.nextSibling);
          if (!p.childNodes.length) p.parentNode.removeChild(p);
          p = br.parentNode;
        }
      });
    }
    function push() {
      if (clean(cur.textContent) || cur.querySelector('img,a')) out.push(cur);
      cur = doc.createElement('div');
    }
    each(el.childNodes, function (n) {
      if (n.nodeType === 1 && n.tagName === 'BR') push(); else cur.appendChild(n.cloneNode(true));
    });
    push();
    return out;
  }

  function boldText(line) {
    var t = '';
    each(line.querySelectorAll('strong,b'), function (b) {
      if (!b.parentElement.closest('strong,b')) t += b.textContent;
    });
    return t;
  }

  function isHeadingLine(line, alone) {
    var all = clean(line.textContent);
    if (all.length < 2 || all.length > 60 || /[.!?]$/.test(all)) return false;
    var b = bare(boldText(line));
    if (b.length >= 2 && b === bare(all)) return true;
    // "🔑 Key Features" typed as plain text on its own line
    return !!alone && all.length <= 40 && EMOJI_START.test(all) && bare(all).length >= 3;
  }

  function stripBullet(line) {
    var w = line.ownerDocument.createTreeWalker(line, 4, null), n;
    while ((n = w.nextNode())) {
      if (!clean(n.nodeValue)) continue;
      n.nodeValue = n.nodeValue.replace(BULLET, '');
      break;
    }
    return line;
  }

  function item(type, node, pid) {
    var text = clean(node.textContent);
    // Also read "Warranty (Years):1" (no space) and "Height 40 mm" (no colon) as label and value.
    return { type: type, html: node.innerHTML.trim(), text: text, pid: pid, kv: KV.exec(text) || KV_TIGHT.exec(text) || KV_DIM.exec(text) };
  }

  function boldKey(line) {
    var f = line.firstElementChild;
    return !!f && /^(STRONG|B)$/.test(f.tagName) && /[:：]\s*$/.test(f.textContent) &&
      !clean(line.textContent).indexOf(clean(f.textContent)) && clean(line.textContent).length > clean(f.textContent).length;
  }

  function parse(rte) {
    var doc = rte.ownerDocument, pid = 0;
    var intro = { title: '', items: [] }, sections = [], meta = [], cur = intro;
    function open(t, soft, level) {
      var name = title(t);
      // A bold label inside a container section (Technical Specifications > Connectivity) is a sub-group, not a new section.
      if ((soft || (level && cur.level && level > cur.level)) && cur !== intro && T_BOX.test(cur.title) && !T_TOP.test(name) && !T_META.test(name) && !T_INTRO.test(name) &&
          (!cur.items.length || cur.grouped)) {
        cur.grouped = true;
        cur.items.push({ type: 'group', html: esc(name), text: name, pid: ++pid, kv: null });
        return;
      }
      cur = { title: name, items: [], soft: !!soft, level: level || 0 };
      sections.push(cur);
    }

    // A bold section name in the middle of a paragraph ("...<br><b>Part Number(s)</b>") starts a new section there.
    function para(el) {
      var chunk = [];
      lines(el).forEach(function (l) {
        var t = title(l.textContent);
        if (chunk.length && isHeadingLine(l, false) && (T_TOP.test(t) || T_META.test(t))) { paraLines(chunk); chunk = []; }
        chunk.push(l);
      });
      paraLines(chunk);
    }

    function paraLines(ls) {
      if (!ls.length) return;
      pid++;
      // "Product Code - CHR-139" on a line of its own is the part number, not part of the section above it.
      var code = ls.length === 1 && !ls[0].querySelector('a,img') ? CODE_LINE.exec(clean(ls[0].textContent)) : null;
      if (code) { meta.push({ title: title(code[1]), items: [{ type: 'para', html: esc(code[2]), text: code[2], pid: pid }] }); return; }
      if (isHeadingLine(ls[0], ls.length === 1)) { open(ls[0].textContent, true); ls.shift(); }
      if (!ls.length) return;
      // A short plain line followed only by "Label: value" lines ("Paper Support", then its specs) starts a section of its own.
      var lead = clean(ls[0].textContent);
      if (ls.length >= 3 && lead.length <= 40 && lead.indexOf(':') < 0 && !/[.!?,;]$/.test(lead) &&
          !KV.test(lead) && ls.slice(1).filter(function (l) { return KV.test(clean(l.textContent)); }).length >= (ls.length - 1) * 0.75) {
        if (cur === intro || cur.items.length) { cur = { title: title(lead), items: [], soft: true, level: 0 }; sections.push(cur); }
        ls.shift();
      }
      // Loose "Label: value" lines with a bold label (Colour, Item Code...) go to the footer strip.
      if (ls.every(boldKey) && ls.length <= 4) {
        var pairs = ls.map(function (l) { return KV.exec(clean(l.textContent)); });
        var allMeta = pairs.every(function (m) { return m && T_META.test(title(m[1])); });
        if (allMeta || !T_SPEC.test(cur.title)) {
          pairs.forEach(function (m) {
            if (m) meta.push({ title: title(m[1]), items: [{ type: 'para', html: esc(m[2]), text: m[2], pid: pid }] });
          });
          return;
        }
      }
      var multi = ls.length > 1;
      ls.forEach(function (l) {
        // Remember which lines were written as bullets: under a "Label:" line they are that label's sub-items.
        var bulleted = BULLET.test(clean(l.textContent) + ' ');
        var it = item(multi ? 'line' : 'para', stripBullet(l), pid);
        it.bul = bulleted;
        cur.items.push(it);
      });
    }

    function walk(parent) {
      each(parent.childNodes, function (n) {
        if (n.nodeType === 3) {
          if (clean(n.nodeValue)) { var p = doc.createElement('p'); p.textContent = n.nodeValue; para(p); }
          return;
        }
        if (n.nodeType !== 1) return;
        var tag = n.tagName;
        if (tag === 'HR' || tag === 'BR') return;
        if (/^H[1-6]$/.test(tag)) { if (clean(n.textContent)) open(n.textContent, false, +tag.charAt(1)); return; }
        if (tag === 'UL' || tag === 'OL') {
          pid++;
          // A line break inside a bullet ends the bullet: lines typed after it ("Material: ABS") are rows of their own.
          var parts = [], broken = false;
          each(n.children, function (li) {
            if (li.tagName !== 'LI') return;
            var ls = lines(li.querySelectorAll(':scope > p').length === 1 ? li.querySelector(':scope > p') : li);
            if (ls.length > 1 && !/[:：]$/.test(clean(ls[0].textContent)) && ls.slice(1).some(function (l) { var t = clean(l.textContent); return KV.test(t) || /[:：]$/.test(t); })) broken = true;
            parts.push(ls);
          });
          if (broken) {
            parts.forEach(function (ls) {
              ls.forEach(function (l, i) { var it = item('line', stripBullet(l), pid); it.bul = i === 0; cur.items.push(it); });
            });
            return;
          }
          // "Lamp Life:" on its own line followed by a list: fold the list into that label's value.
          var last = cur.items[cur.items.length - 1];
          if (last && !last.kv && (last.type === 'line' || last.type === 'para') && /[:：]$/.test(last.text) && last.text.length <= 48) {
            var vals = [];
            each(n.children, function (li) { if (li.tagName === 'LI' && clean(li.textContent)) vals.push(clean(li.textContent)); });
            if (vals.length && vals.length <= 8) {
              var name = title(last.text), joined = vals.join(', ');
              cur.items.pop();
              cur.items.push({ type: 'line', html: esc(name + ': ' + joined), text: name + ': ' + joined, pid: pid, kv: [null, name, joined],
                vh: vals.map(function (v) { var m = KV.exec(v); return m ? '<b>' + esc(m[1]) + ':</b> ' + esc(m[2]) : esc(v); }).join('<br>') });
              return;
            }
          }
          each(n.children, function (li) {
            if (li.tagName !== 'LI') return;
            var d = doc.createElement('div'), ps = li.querySelectorAll(':scope > p');
            if (ps.length === 1 && clean(li.textContent) === clean(ps[0].textContent)) d.innerHTML = ps[0].innerHTML;
            else d.innerHTML = li.innerHTML;
            if (clean(d.textContent)) cur.items.push(item('li', stripBullet(d), pid));
          });
          return;
        }
        if (RAW_TAGS.test(tag) || (tag === 'P' && n.querySelector('img,iframe,video') && !clean(n.textContent))) {
          if (tag === 'P' && !n.querySelector('img[src],iframe,video')) return;
          cur.items.push({ type: 'raw', html: n.outerHTML, text: '', pid: ++pid, kv: null });
          return;
        }
        // Any wrapper (div, article, pasted page markup...) that holds real blocks: look inside it.
        if (!TEXT_TAGS.test(tag) && n.querySelector('p,ul,ol,h1,h2,h3,h4,h5,h6,table')) { walk(n); return; }
        para(n);
      });
    }
    walk(rte);

    // A sub-group label with nothing under it is content too.
    sections.forEach(function (s) {
      s.items.forEach(function (it, i) {
        var next = s.items[i + 1];
        if (it.type === 'group' && (!next || next.type === 'group')) { it.type = 'para'; it.html = '<strong>' + it.html + '</strong>'; }
      });
    });
    // A bold line with nothing under it was content, not a heading: hand it back to the section before it.
    sections.forEach(function (s, i) {
      if (s.items.length || !s.soft || !s.title || T_META.test(s.title)) return;
      var prev = null;
      for (var j = i - 1; j >= 0; j--) if (sections[j].items.length) { prev = sections[j]; break; }
      (prev || intro).items.push({ type: 'para', html: '<strong>' + esc(s.title) + '</strong>', text: s.title, pid: ++pid, kv: null });
    });
    // No opening paragraph, but the first section is plain prose: use it as the intro.
    var first = sections.filter(function (s) { return s.items.length; })[0];
    if (!intro.items.length && first && !T_TOP.test(first.title) && !T_META.test(first.title) &&
        first.items.every(function (i) { return i.type === 'para' && !i.kv; })) {
      intro.items = first.items; first.items = [];
    }

    // Classify
    var out = { intro: intro.items.slice(), left: [], right: [], meta: [] };
    sections.forEach(function (s) {
      if (!s.items.length) return;
      var rows = s.items.filter(function (i) { return i.type !== 'group'; });
      if (!rows.length) return;
      var n = rows.length, kv = rows.filter(function (i) { return i.kv; }).length;
      var raw = s.items.some(function (i) { return i.type === 'raw'; });
      var len = s.items.reduce(function (a, i) { return a + i.text.length; }, 0);
      if (T_INTRO.test(s.title) && !raw) { out.intro = out.intro.concat(s.items); return; }
      if (T_META.test(s.title) && len <= 240 && !raw) { out.meta.push(s); return; }
      // "Physical Features" made only of "Label: value" lines is a spec section, not a feature list.
      var listTitle = T_LIST.test(s.title) && !(kv >= 2 && kv / n >= 0.8);
      if (!raw && !listTitle && (T_SPEC.test(s.title) || (kv >= 2 && kv / n >= 0.6))) { s.kind = 'spec'; out.right.push(s); return; }
      s.kind = 'list';
      out.left.push(s);
    });
    out.meta = out.meta.concat(meta);
    // Colour gets its own section with swatches instead of sitting in the spec table.
    var hasColour = out.meta.some(function (m) { return T_COLOUR.test(m.title); });
    out.right.forEach(function (s) {
      var grouped = false;
      s.items = s.items.filter(function (i) {
        if (i.type === 'group') grouped = true;
        if (grouped || hasColour || !i.kv || !/^colou?rs?(\(s\))?( options)?$/i.test(clean(i.kv[1])) || clean(i.kv[2]).length > 120) return true;
        hasColour = true;
        var v = clean(i.kv[2]);
        out.meta.unshift({ title: /,|\/|&|\band\b/i.test(v) ? 'Colours' : 'Colour', items: [{ type: 'para', html: esc(v), text: v, pid: 0 }] });
        return false;
      });
    });
    out.right = out.right.filter(function (s) { return s.items.length; });
    // A very long flat spec table is easier to read with its connectivity, power and build rows in sections of their own.
    var split = [];
    out.right.forEach(function (s) {
      split.push(s);
      if (!T_TABLE.test(s.title) || s.grouped || s.items.length <= 16) return;
      SPLITS.forEach(function (rule) {
        var hit = s.items.filter(function (i) { return i.kv && rule.re.test(clean(i.kv[1])); });
        if (hit.length < 2 || hit.length > s.items.length * 0.5) return;
        s.items = s.items.filter(function (i) { return hit.indexOf(i) < 0; });
        split.push({ title: rule.title, items: hit, kind: 'spec' });
      });
    });
    out.right = split;
    return out;
  }

  /* ---------- rendering ---------- */

  function renderParas(items) {
    var html = '', i = 0;
    while (i < items.length) {
      if (items[i].type === 'raw') { html += items[i].html; i++; continue; }
      var p = items[i].pid, parts = [];
      while (i < items.length && items[i].pid === p && items[i].type !== 'raw') { parts.push(items[i].html); i++; }
      html += '<p>' + parts.join('<br>') + '</p>';
    }
    return html;
  }

  function listy(s) {
    var singles = s.items.filter(function (i) { return i.type === 'para' && i.text.length < 220 && !/[:：]$/.test(i.text); }).length;
    return function (i) {
      if (i.type === 'group' || i.type === 'raw') return false;
      if (i.type === 'li') return true;
      if (i.type === 'line') return !/[:：]$/.test(i.text);
      return singles >= 2 && i.text.length < 220 && !/[:：]$/.test(i.text);
    };
  }

  // "<strong>Name</strong> – text" or "Name – text" becomes a titled card.
  function splitFeature(it) {
    var m = /^<(strong|b)\b[^>]*>([\s\S]*?)<\/\1>\s*(?:[–—:-]\s*)?([\s\S]+)$/.exec(it.html);
    if (m && clean(strip(m[2])).length <= 48 && clean(strip(m[3]))) return { t: m[2].replace(/[:：]\s*$/, ''), d: m[3] };
    var i = it.text.search(/\s[–—]\s/);
    if (i > 1 && i <= 40 && it.html.indexOf('<') === -1) return { t: esc(it.text.slice(0, i)), d: esc(it.text.slice(i).replace(/^\s[–—]\s/, '')) };
    return null;
  }

  function card(t, d) {
    return '<li>' + CHECK_SVG + '<div>' + (t ? '<strong class="oru-checks__title">' + t + '</strong>' : '') + (d ? '<span class="oru-checks__text">' + d + '</span>' : '') + '</div></li>';
  }

  function renderFeatures(s) {
    var is = listy(s), html = '', cards = '', k = 0, items = s.items;
    // Titled items only when every feature has a title; a mix of styles looks broken.
    var plain = items.filter(function (i) { return is(i); });
    var titled = plain.length >= 2 && plain.every(function (i) { return splitFeature(i); });
    function flush() { if (cards) { html += '<ul class="oru-checks">' + cards + '</ul>'; cards = ''; } }
    while (k < items.length) {
      var it = items[k];
      if (it.type === 'raw') { flush(); html += '<div class="rte">' + it.html + '</div>'; k++; continue; }
      if (it.type === 'group') {
        var body = ''; k++;
        while (k < items.length && items[k].type !== 'group' && items[k].type !== 'raw') { body += '<span class="oru-checks__line">' + items[k].html + '</span>'; k++; }
        cards += card(it.html, body);
        continue;
      }
      if (!is(it)) { flush(); html += '<p>' + it.html + '</p>'; k++; continue; }
      var f = titled ? splitFeature(it) : null;
      cards += f ? card(f.t, f.d) : card('', it.html);
      k++;
    }
    flush();
    return html;
  }

  function chipsOk(s) {
    var is = listy(s);
    return s.items.length >= 2 && s.items.every(function (i) { return is(i) && i.text.length <= 42 && i.html.indexOf('<') === -1; });
  }

  function renderChips(s) {
    return '<ul class="oru-chips">' + s.items.map(function (i) { return '<li>' + i.html + '</li>'; }).join('') + '</ul>';
  }

  function renderList(s) {
    var is = listy(s), items = s.items, html = '', k = 0;
    while (k < items.length) {
      var it = items[k];
      if (it.type === 'raw') { html += '<div class="rte">' + it.html + '</div>'; k++; continue; }
      if (it.type === 'group') { html += '<h5 class="oru-sub">' + it.html + '</h5>'; k++; continue; }
      if (!is(it)) { html += '<p>' + it.html + '</p>'; k++; continue; }
      html += '<ul class="oru-list">';
      while (k < items.length && is(items[k])) { html += '<li>' + items[k].html + '</li>'; k++; }
      html += '</ul>';
    }
    return html;
  }

  // Turn a spec section into label/value cells, so no line is left without a label.
  function specCells(s) {
    var cells = [], loose = [], items = s.items, k = 0, isDim = /dimension/i.test(s.title);
    var dimLabel = isDim ? ((/\(([^)]+)\)/.exec(s.title) || [])[1] || 'Size') : '';
    function line(g) { return g.kv ? '<b>' + esc(clean(g.kv[1])) + ':</b> ' + (g.vh || esc(clean(g.kv[2]))) : g.html; }
    function labelOnly(g) { return g && !g.kv && g.type !== 'group' && g.type !== 'raw' && /[:：]$/.test(g.text) && g.text.length <= 48; }
    // A lone sub-heading over the whole section ("Main Unit") adds nothing: show its rows directly.
    if (items[0].type === 'group' && items.filter(function (g) { return g.type === 'group'; }).length === 1) items = items.slice(1);
    while (k < items.length) {
      var i = items[k];
      if (i.type === 'group') {
        // A sub-heading and everything under it become one cell.
        var parts = []; k++;
        while (k < items.length && items[k].type !== 'group') { parts.push(line(items[k])); k++; }
        cells.push({ k: i.html, v: parts.join('<br>') });
        continue;
      }
      if (labelOnly(i)) {
        // "WiFi Speed:" followed by plain or bulleted lines: those lines are its value. Followed by more labels: it is a sub-heading.
        var vals = []; k++;
        while (k < items.length && items[k].type !== 'group' && !labelOnly(items[k]) && (!items[k].kv || items[k].bul)) { vals.push(line(items[k])); k++; }
        if (vals.length) cells.push({ k: esc(title(i.text)), v: vals.join('<br>') });
        else cells.push({ k: esc(title(i.text)), head: true });
        continue;
      }
      if (i.kv) cells.push({ k: esc(clean(i.kv[1])), v: i.vh || esc(clean(i.kv[2])) });
      else if (dimLabel && /\d/.test(i.text) && i.text.length <= 60 && i.html.indexOf('<') === -1) cells.push({ k: esc(dimLabel), v: i.html });
      else if (isDim && /\d/.test(i.text) && cells.length && !cells[cells.length - 1].head) cells[cells.length - 1].v += '<br>' + i.html;
      else loose.push(i.html);
      dimLabel = '';
      k++;
    }
    // Stray lines with no label of their own are gathered into one labelled cell.
    if (loose.length) cells.push({ k: 'Other details', v: loose.join('<br>'), loose: loose });
    return cells;
  }

  // A section named like a spec list but written mostly as plain lines reads better as a bullet list.
  function plainList(cells) {
    var labelled = cells.filter(function (c) { return c.k && !c.loose && !c.head; });
    var loose = cells.filter(function (c) { return c.loose; })[0];
    var stray = loose ? loose.loose.length : 0;
    if (!(labelled.length === 0 || (labelled.length <= 1 && stray >= 2))) return '';
    var lines = labelled.map(function (c) { return '<b>' + c.k + ':</b> ' + c.v; }).concat(loose ? loose.loose : []);
    return lines.length ? '<ul class="oru-list">' + lines.map(function (v) { return '<li>' + v + '</li>'; }).join('') + '</ul>' : '';
  }

  // Technical specifications: a two-up table.
  function renderSpec(s) {
    var cells = specCells(s);
    return plainList(cells) || '<div class="oru-rows">' + cells.map(function (c) {
      if (c.head) return '<div class="oru-row oru-row--group">' + c.k + '</div>';
      // A long value gets the full table width instead of one tall, narrow cell.
      var wide = strip(c.v).length > 120, ls = c.v.split('<br>'), split = wide && ls.length > 3;
      // Many short lines sit in two columns; each line is kept whole.
      var v = split ? ls.map(function (l) { return '<span class="oru-row__line">' + l + '</span>'; }).join('') : c.v;
      return '<div class="oru-row' + (wide ? ' oru-row--wide' : '') + (split ? ' oru-row--split' : '') + '"><span class="oru-row__k">' + c.k + '</span><span class="oru-row__v">' + v + '</span></div>';
    }).join('') + '</div>';
  }

  // Every other label/value section (dimensions, power, paper handling...): a grid of fact cards.
  function renderFacts(s) {
    var cells = specCells(s);
    return plainList(cells) || '<div class="oru-facts">' + cells.map(function (c) {
      if (c.head) return '<h5 class="oru-sub oru-facts__head">' + c.k + '</h5>';
      return '<div class="oru-fact' + (strip(c.v).length > 120 ? ' oru-fact--wide' : '') + '"><span class="oru-fact__k">' + c.k + '</span><span class="oru-fact__v">' + c.v + '</span></div>';
    }).join('') + '</div>';
  }

  function codes(text) {
    return text.split(/[,;\n](?![^(]*\))|\s\/\s/).map(clean).filter(Boolean);
  }

  // Split a colour value into names, keeping anything in brackets attached to its name.
  function colourList(text) {
    var held = [];
    var masked = text.replace(/\([^()]*\)/g, function (m) { held.push(m); return '\u0001' + (held.length - 1) + '\u0001'; });
    // In a comma list a slash joins the two tones of one option ("Silver/Black, Silver/Blue"); on its own it separates names.
    var cut = masked.indexOf(',') > -1 ? /\s*(?:,|&|\band\b|\bor\b)\s*/i : /\s*(?:,|\/|&|\band\b|\bor\b)\s*/i;
    return masked.split(cut).map(function (p) {
      return clean(p.replace(/\u0001(\d+)\u0001/g, function (m, n) { return held[+n]; }));
    }).filter(Boolean);
  }

  function hasSwatch(name) {
    return name.toLowerCase().split(/[\s-]+/).some(function (w) { return SWATCH[w]; });
  }

  // "Red, Green and Blue (assorted)" -> three colours plus a note for the whole list.
  function parseColours(text) {
    text = clean(text);
    if (!text || text.length > 160 || /[;:]/.test(text)) return null;
    var note = '', m;
    // "10 assorted per pack - white, yellow, pink"
    if ((m = /^([^,(]{3,40}?)\s[-–—]\s(.+)$/.exec(text)) && colourList(m[2]).length >= 2) { note = m[1]; text = m[2]; }
    var names = colourList(text), last = names[names.length - 1] || '';
    if (names.length >= 2 && (m = /^(.*\S)\s*\(([^()]+)\)$/.exec(last)) && names.slice(0, -1).every(function (n) { return n.indexOf('(') < 0; })) {
      // The bracket describes the whole list, not the last colour.
      names[names.length - 1] = m[1]; note = note || m[2];
    } else if (names.length === 1 && (m = /^([^(]+?)\s*\(([^()]+)\)$/.exec(last)) && !hasSwatch(m[1]) && colourList(m[2]).length >= 2) {
      // "Assorted (red, blue, yellow)": the bracket is the list.
      note = note || m[1]; names = colourList(m[2]);
    }
    if (!names.length || !names.every(function (n) { return n.length <= 40; })) return null;
    // "Black / dark grey" on a product with no such colour choice is one two-tone item, not two colours to pick from.
    if (curOptions && !note && names.length > 1 && text.indexOf(',') < 0 && text.length <= 40 &&
        !names.some(function (n) { return curOptions.indexOf(n.toLowerCase()) > -1; })) return { names: [text], note: note, one: true };
    return { names: names, note: note };
  }

  function renderMeta(s) {
    var text = s.items.map(function (i) { return i.text; }).join('\n');
    if (T_CODES.test(s.title)) {
      var list = codes(text);
      if (list.length && list.every(function (c) { return c.length <= 60; })) {
        return '<div class="oru-codes">' + list.map(function (c) {
          // "EL9004-2 (AA, 2 pack)", "RD106 - 1 inch" or "1 inch – RD106": main part plus a muted note.
          var m = /^(\S+)\s*\((.*)\)$/.exec(c) || /^(.{1,24}?)\s+[-–—]\s+(.{1,40})$/.exec(c);
          return '<span class="oru-code" data-code="' + esc(c).replace(/"/g, '&quot;') + '">' + esc(m ? m[1] : c) + (m ? ' <em>' + esc(m[2]) + '</em>' : '') + '</span>';
        }).join('') + '</div>';
      }
    }
    var col = T_COLOUR.test(s.title) ? parseColours(text) : null;
    if (col) {
      var mix = /assort|random/i.test(col.note);
      var note = col.note ? col.note.charAt(0).toUpperCase() + col.note.slice(1) : '';
      if (/assort/i.test(col.note)) note = (/^assorted( colou?rs?)?$/i.test(col.note) ? 'Assorted' : note) + ". Supplied as a mix, so individual colours can't be chosen.";
      return '<div class="oru-codes' + (mix ? ' oru-codes--mix' : '') + '">' + col.names.map(function (n) {
        var m = /^(.*\S)\s*\(([^()]+)\)$/.exec(n), base = m ? m[1] : n;
        var keys = base.toLowerCase().split(/[^a-z]+/).filter(function (w) { return SWATCH[w]; }), key = keys[keys.length - 1];
        // A two-tone item gets a split swatch.
        var fill = (col.one || base.indexOf('/') > -1) && keys.length > 1 ? 'linear-gradient(90deg,' + SWATCH[keys[0]] + ' 50%,' + SWATCH[key] + ' 50%)' : SWATCH[key];
        return '<span class="oru-code oru-code--colour" data-colour="' + esc(base).replace(/"/g, '&quot;') + '">' + (key ? '<i style="background:' + fill + '"></i>' : '') + esc(base) + (m ? ' <em>' + esc(m[2]) + '</em>' : '') + '</span>';
      }).join('') + '</div>' + (note ? '<p class="oru-note">' + esc(note) + '</p>' : '');
    }
    if (s.items.length > 1 && s.items.every(function (i) { return i.type !== 'raw' && i.text.length <= 90; })) {
      return '<ul class="oru-list">' + s.items.map(function (i) { return '<li>' + i.html + '</li>'; }).join('') + '</ul>';
    }
    return renderParas(s.items);
  }

  // Pick up to four short facts for the "At a glance" panel from the spec rows.
  function glance(model) {
    var rows = [], tiles = [], dims = [], seen = {};
    model.right.forEach(function (s) {
      var grouped = false;
      s.items.forEach(function (i) {
        if (i.type === 'group') grouped = true;
        // Rows under a sub-heading ("Print Speed > Colour") make no sense on their own, apart from sizes.
        if (i.kv && (!grouped || DIM_KEY.test(clean(i.kv[1])))) rows.push({ k: clean(i.kv[1]), v: clean(i.kv[2]), sec: s.title });
        else if (!i.kv && i.type !== 'group' && /dimension/i.test(s.title) && /\d/.test(i.text) && i.text.length <= 46 && !tiles.length) tiles.push({ k: s.title, v: i.text, wide: true, order: -1 });
      });
    });
    if (!tiles.length) {
      rows.some(function (r, n) {
        if (!DIM_KEY.test(r.k)) return false;
        var m = DIM_VAL.exec(r.v), letter = /^diam/i.test(r.k) ? 'Ø' : r.k.charAt(0).toUpperCase();
        if (!m || seen[letter]) return dims.length >= 2;
        seen[letter] = 1; dims.push({ l: letter, n: m[1], u: m[2].toLowerCase(), order: n });
        return false;
      });
      if (dims.length >= 2) {
        var same = dims.every(function (d) { return d.u === dims[0].u; });
        tiles.push({ k: 'Size (' + dims.map(function (d) { return d.l; }).join(' × ') + ')', v: dims.map(function (d) { return d.n + (same ? '' : ' ' + d.u); }).join(' × ') + (same ? ' ' + dims[0].u : ''), wide: true, order: -1 });
      }
    }
    var pool = [];
    rows.forEach(function (r, n) {
      var v = clean(r.v.replace(/\s*\([^)]*\)/g, ''));
      if (DIM_KEY.test(r.k) || /^type$/i.test(r.k) || (tiles.length && /^(size|dimensions?)$/i.test(r.k)) || r.k.length < 3 || r.k.length > 26 || !v || v.length > 28) return;
      pool.push({ k: r.k, v: v, order: n });
    });
    model.meta.forEach(function (s, n) {
      var v = s.items.map(function (i) { return i.text; }).join(', ');
      if (T_COLOUR.test(s.title) && v.length <= 28) pool.push({ k: s.title, v: v, order: 1000 + n });
    });
    var want = 4 - tiles.length * (tiles.length ? 2 : 0), picked = [];
    PRIORITY.forEach(function (re) {
      pool.forEach(function (p) { if (picked.length < want && picked.indexOf(p) < 0 && re.test(p.k)) picked.push(p); });
    });
    pool.forEach(function (p) { if (picked.length < want && picked.indexOf(p) < 0) picked.push(p); });
    tiles = tiles.concat(picked).sort(function (a, b) { return a.order - b.order; });
    if (tiles.length < 2) return [];
    return tiles;
  }

  // Every section is the same band: its name on the left, its content on the right.
  function band(label, body) {
    return '<section class="oru-band"><h3 class="oru-band__label">' + esc(label) + '</h3><div class="oru-band__body">' + body + '</div></section>';
  }

  function render(model, label) {
    var html = '<div class="oru-sheet">', tiles = glance(model);
    var stats = tiles.length ? '<dl class="oru-stats">' + tiles.map(function (t) {
      return '<div class="oru-stat"><dd>' + esc(t.v) + '</dd><dt>' + esc(t.k) + '</dt></div>';
    }).join('') + '</dl>' : '';
    if (model.intro.length) html += band(label, '<div class="oru-intro">' + renderParas(model.intro) + '</div>' + stats);
    else if (stats) html += band('At a glance', stats);
    var later = '';
    model.left.forEach(function (s) {
      if (T_CHECK.test(s.title)) html += band(s.title, renderFeatures(s));
      else if (chipsOk(s)) html += band(s.title, renderChips(s));
      else later += band(s.title, renderList(s));
    });
    model.right.forEach(function (s) { html += band(s.title.replace(/\s*\([HWDLTØ×xX\s]+\)$/, ''), T_TABLE.test(s.title) ? renderSpec(s) : renderFacts(s)); });
    html += later;
    model.meta.forEach(function (s) {
      var body = renderMeta(s);
      // One two-tone item is a "Colour", not "Colours".
      html += band(s.title === 'Colours' && body.split('oru-code--colour').length === 2 ? 'Colour' : s.title, body);
    });
    return html + '</div>';
  }

  // Highlight the part number and colour that belong to the selected variant.
  function markVariant(sheet, sku, options) {
    sku = (sku || '').toUpperCase();
    options = (options || []).map(function (o) { return clean(String(o)).toLowerCase(); }).filter(Boolean);
    var chips = Array.prototype.slice.call(sheet.querySelectorAll('.oru-code[data-code]')), best = null, score = 0;
    chips.forEach(function (c) {
      c.classList.remove('is-selected');
      if (chips.length < 2) return;
      var text = c.getAttribute('data-code') || '', n = 0;
      // Strongest signal: a code from the chip appears inside the variant SKU.
      (text.toUpperCase().match(/[A-Z0-9]+(?:[-.][A-Z0-9]+)*/g) || []).forEach(function (t) {
        if (t.length >= 3 && (/\d/.test(t) || t.length >= 5) && sku.indexOf(t) > -1) n = Math.max(n, 100 + t.length);
      });
      // Otherwise: the chip names the selected option ("1 inch", "AAA", "Black").
      if (!n) {
        var parts = text.toLowerCase().split(/\s[-–—]\s|[(),]/).map(clean);
        options.forEach(function (o) { if (parts.indexOf(o) > -1) n++; });
      }
      if (n > score) { score = n; best = c; }
    });
    if (best) best.classList.add('is-selected');
    var colours = sheet.querySelectorAll('.oru-code--colour');
    each(colours, function (c) {
      c.classList.toggle('is-selected', colours.length > 1 && !c.closest('.oru-codes--mix') && options.indexOf(clean(c.getAttribute('data-colour') || '').toLowerCase()) > -1);
    });
  }

  function variantOptions(host) {
    try { return JSON.parse(host.getAttribute('data-oru-options') || '[]'); } catch (e) { return []; }
  }

  // Option values of the selected variant (lower case), or null when unknown.
  var curOptions = null;

  function make(rte, label) {
    var before = bare(rte.textContent).length;
    var model = parse(rte);
    if (!model.intro.length && !model.left.length && !model.right.length && !model.meta.length) return null;
    var tmp = document.createElement('div');
    tmp.innerHTML = render(model, label || 'About this product');
    var sheet = tmp.firstChild;
    // Safety net: if the rebuilt sheet lost a meaningful share of the text, keep the original description.
    var glanceEl = sheet.querySelector('.oru-stats');
    var after = bare(sheet.textContent).length - (glanceEl ? bare(glanceEl.textContent).length : 0);
    return after < before * 0.9 ? null : sheet;
  }

  function build(host) {
    try {
      if (!host || host.querySelector('.oru-sheet')) return false;
      var card = host.querySelector('.card'), rte = host.querySelector('.rte');
      if (!card || !rte) return false;
      curOptions = host.hasAttribute('data-oru-options') ? variantOptions(host).map(function (o) { return clean(String(o)).toLowerCase(); }) : null;
      var sheet = make(rte, host.getAttribute('data-oru-label'));
      curOptions = null;
      if (!sheet) return false;
      card.innerHTML = '';
      card.appendChild(sheet);
      host.classList.add('oru-sheet-host--ready');
      markVariant(sheet, host.getAttribute('data-oru-sku'), variantOptions(host));
      return true;
    } catch (e) { return false; }
  }

  // A description shown inside a narrow column (the home page "Featured product" block) is restyled in place.
  function buildInline(rte) {
    try {
      if (rte.querySelector('.oru-sheet')) return false;
      var sheet = make(rte);
      if (!sheet) return false;
      rte.innerHTML = '';
      rte.appendChild(sheet);
      rte.classList.remove('rte');
      rte.classList.add('oru-inline');
      return true;
    } catch (e) { return false; }
  }

  // Take the theme's description card out of the narrow left column and place it full width under the gallery and buy box.
  function adopt(item) {
    if (item.classList.contains('oru-sheet-host')) return item;
    if (item.querySelector('.card__collapsible-button, .expandable-content') || !item.querySelector('.card .rte')) return null;
    var list = item.closest('.product-block-list');
    if (!list || !list.parentNode) return null;
    list.parentNode.insertBefore(item, list.nextSibling);
    item.classList.add('oru-sheet-host');
    return item;
  }

  function init(cfg) {
    cfg = cfg || window.ORUSheetConfig || {};
    each(document.querySelectorAll('[data-section-type="product"] .product-block-list__item--description'), function (item) {
      var host = adopt(item);
      if (!host) return;
      if (cfg.label) host.setAttribute('data-oru-label', cfg.label);
      if (cfg.sku != null && !host.hasAttribute('data-oru-sku')) host.setAttribute('data-oru-sku', cfg.sku);
      if (cfg.options && !host.hasAttribute('data-oru-options')) host.setAttribute('data-oru-options', JSON.stringify(cfg.options));
      build(host);
    });
    each(document.querySelectorAll('.product-info__block-item--featured-description .product-meta__description'), function (rte) {
      if (rte.closest('template')) return;
      buildInline(rte);
      // The theme re-renders this block when a variant is picked; restyle it again when that happens.
      var sec = rte.closest('.shopify-section');
      if (sec && window.MutationObserver && !sec.oruWatched) {
        sec.oruWatched = true;
        new MutationObserver(function () { init(); }).observe(sec, { childList: true, subtree: true });
      }
    });
  }

  window.ORUSheet = { parse: parse, render: render, build: build, init: init };
  init();
  if (!window.ORUSheetBound) {
    window.ORUSheetBound = true;
    document.addEventListener('variant:changed', function (e) {
      var v = e.detail && e.detail.variant;
      each(document.querySelectorAll('.oru-sheet-host'), function (h) {
        if (!v) return;
        h.setAttribute('data-oru-sku', v.sku || '');
        h.setAttribute('data-oru-options', JSON.stringify(v.options || [v.option1, v.option2, v.option3].filter(Boolean)));
        var s = h.querySelector('.oru-sheet');
        if (s) markVariant(s, v.sku, variantOptions(h));
      });
    });
    var again = function () { init(); };
    document.addEventListener('shopify:section:load', again);
    document.addEventListener('DOMContentLoaded', again);
    // The theme swaps the whole product block when a variant links to another product; rebuild if that happens.
    var box = document.querySelector('[data-section-type="product"] > .container');
    if (box && window.MutationObserver) new MutationObserver(again).observe(box, { childList: true });
  }
})();
